// Seasonal and Holiday Homepage Themes Configuration
export const homepageThemes = {
  default: {
    name: 'Default',
    gradient: 'from-blue-50 via-white to-indigo-50',
    particles: [],
  },
  
  // SEASONAL THEMES
  winter: {
    name: 'Winter',
    gradient: 'from-blue-200 via-cyan-100 to-white',
    particles: [
      { type: 'snowflake', count: 25, size: 'sm' },
      { type: 'snowflake', count: 15, size: 'md' },
      { type: 'snowflake', count: 8, size: 'lg' },
      { type: 'emoji', count: 3, emoji: '☃️', size: 'lg' },
      { type: 'emoji', count: 4, emoji: '❄️', size: 'xl' },
    ],
    accent: '#3B82F6', // blue-500
    overlay: 'winter-frost',
  },
  
  spring: {
    name: 'Spring',
    gradient: 'from-emerald-200 via-teal-100 to-sky-200',
    particles: [
      { type: 'flower', count: 12, emoji: '🌷', size: 'md' },
      { type: 'flower', count: 10, emoji: '🌺', size: 'md' },
      { type: 'sparkle', count: 15, emoji: '✨', size: 'sm' },
      { type: 'emoji', count: 8, emoji: '☘️', size: 'sm' },
      { type: 'emoji', count: 6, emoji: '🌸', size: 'lg' },
      { type: 'emoji', count: 5, emoji: '🦋', size: 'md' },
      { type: 'emoji', count: 4, emoji: '🌼', size: 'md' },
    ],
    accent: '#10B981', // emerald-500
  },
  
  summer: {
    name: 'Summer',
    gradient: 'from-yellow-200 via-orange-100 to-amber-200',
    particles: [
      { type: 'sun-ray', count: 20, size: 'sm' },
      { type: 'sparkle', count: 15, emoji: '✨', size: 'sm' },
      { type: 'emoji', count: 6, emoji: '☀️', size: 'xl' },
      { type: 'emoji', count: 8, emoji: '🌻', size: 'lg' },
      { type: 'emoji', count: 6, emoji: '🏖️', size: 'md' },
      { type: 'emoji', count: 5, emoji: '🍉', size: 'md' },
      { type: 'emoji', count: 4, emoji: '🌴', size: 'lg' },
    ],
    accent: '#F59E0B', // amber-500
  },
  
  fall: {
    name: 'Fall/Autumn',
    gradient: 'from-orange-200 via-red-100 to-amber-200',
    particles: [
      { type: 'leaf', count: 15, emoji: '🍂', size: 'md' },
      { type: 'leaf', count: 12, emoji: '🍁', size: 'lg' },
      { type: 'emoji', count: 8, emoji: '🎃', size: 'md' },
      { type: 'emoji', count: 6, emoji: '🌰', size: 'sm' },
      { type: 'emoji', count: 5, emoji: '🦃', size: 'lg' },
      { type: 'emoji', count: 4, emoji: '🍄', size: 'md' },
    ],
    accent: '#F97316', // orange-500
  },
  
  // HOLIDAY THEMES
  christmas: {
    name: 'Christmas',
    gradient: 'from-red-200 via-green-100 to-white',
    particles: [
      { type: 'snowflake', count: 20, size: 'md' },
      { type: 'emoji', count: 10, emoji: '🎄', size: 'lg' },
      { type: 'emoji', count: 8, emoji: '⭐', size: 'md' },
      { type: 'emoji', count: 6, emoji: '🎅', size: 'lg' },
      { type: 'emoji', count: 6, emoji: '🎁', size: 'md' },
      { type: 'sparkle', count: 15, emoji: '✨', size: 'sm' },
      { type: 'emoji', count: 5, emoji: '🔔', size: 'sm' },
      { type: 'emoji', count: 4, emoji: '❄️', size: 'xl' },
      { type: 'emoji', count: 3, emoji: '🦌', size: 'md' },
    ],
    accent: '#DC2626', // red-600
    overlay: 'christmas-lights',
  },
  
  halloween: {
    name: 'Halloween',
    gradient: 'from-purple-950 via-indigo-950 to-black',  // Darker, spookier gradient
    particles: [
      { type: 'ghost', count: 15, emoji: '👻', size: 'lg' },  // Flying ghosts with special animation
      { type: 'ghost', count: 10, emoji: '👻', size: 'md' },  // More flying ghosts
      { type: 'emoji', count: 12, emoji: '🎃', size: 'lg' },
      { type: 'emoji', count: 8, emoji: '🦇', size: 'md' },
      { type: 'emoji', count: 6, emoji: '💀', size: 'md' },
      { type: 'emoji', count: 6, emoji: '🕷️', size: 'sm' },
      { type: 'emoji', count: 5, emoji: '🕸️', size: 'xl' },
      { type: 'emoji', count: 3, emoji: '🧛', size: 'lg' },
      { type: 'emoji', count: 3, emoji: '🌙', size: 'xl' },
    ],
    accent: '#7C3AED', // violet-600
    overlay: 'spooky-mist',
  },
  
  thanksgiving: {
    name: 'Thanksgiving',
    gradient: 'from-amber-200 via-orange-100 to-red-100',
    particles: [
      { type: 'emoji', count: 10, emoji: '🦃', size: 'xl' },
      { type: 'leaf', count: 12, emoji: '🍂', size: 'md' },
      { type: 'emoji', count: 8, emoji: '🌽', size: 'md' },
      { type: 'emoji', count: 6, emoji: '🥧', size: 'md' },
      { type: 'emoji', count: 5, emoji: '🍁', size: 'lg' },
      { type: 'emoji', count: 5, emoji: '🍎', size: 'sm' },
      { type: 'emoji', count: 4, emoji: '🎃', size: 'lg' },
      { type: 'emoji', count: 3, emoji: '🌾', size: 'md' },
    ],
    accent: '#D97706', // amber-600
  },
  
  easter: {
    name: 'Easter',
    gradient: 'from-purple-200 via-pink-100 to-yellow-100',
    particles: [
      { type: 'emoji', count: 12, emoji: '🐰', size: 'lg' },
      { type: 'emoji', count: 14, emoji: '🥚', size: 'md' },
      { type: 'flower', count: 10, emoji: '🌷', size: 'md' },
      { type: 'emoji', count: 8, emoji: '🐣', size: 'md' },
      { type: 'emoji', count: 6, emoji: '🌸', size: 'md' },
      { type: 'sparkle', count: 12, emoji: '✨', size: 'sm' },
      { type: 'emoji', count: 5, emoji: '🐥', size: 'sm' },
      { type: 'emoji', count: 4, emoji: '🧺', size: 'md' },
    ],
    accent: '#EC4899', // pink-500
  },
  
  valentines: {
    name: "Valentine's Day",
    gradient: 'from-pink-200 via-red-100 to-purple-100',
    particles: [
      { type: 'emoji', count: 15, emoji: '❤️', size: 'lg' },
      { type: 'emoji', count: 12, emoji: '💕', size: 'md' },
      { type: 'emoji', count: 10, emoji: '💖', size: 'md' },
      { type: 'sparkle', count: 15, emoji: '✨', size: 'sm' },
      { type: 'emoji', count: 8, emoji: '💝', size: 'md' },
      { type: 'emoji', count: 6, emoji: '💘', size: 'md' },
      { type: 'emoji', count: 5, emoji: '💗', size: 'lg' },
      { type: 'emoji', count: 5, emoji: '🌹', size: 'md' },
      { type: 'emoji', count: 4, emoji: '💐', size: 'lg' },
    ],
    accent: '#EC4899', // pink-500
  },
};

// Utility to get theme config
export const getThemeConfig = (themeName = 'default') => {
  return homepageThemes[themeName] || homepageThemes.default;
};

// Get all theme options for admin dropdown
export const getThemeOptions = () => {
  return Object.keys(homepageThemes).map(key => ({
    value: key,
    label: homepageThemes[key].name
  }));
};
